// @flow
import type { ApplicationModalState, IntegrationsState } from "@modules/integrations/types";
import { closedModal } from "./state";

const toModalState = (payload: ?Object): ApplicationModalState => ({
  visible: !!(payload && payload.visible),
  application: (payload && payload.application) || null,
});

export const setLoading = (state: IntegrationsState) => () => ({ ...state, isLoading: true });

export const setLoaded = (state: IntegrationsState) => () => ({ ...state, isLoading: false });

export const onGetApplicationsSuccess = (state: IntegrationsState) => ({ payload }: Object) => ({
  ...state,
  isLoading: false,
  list: payload || [],
});

export const onGetApplicationDetails = (state: IntegrationsState) => () => ({
  ...state,
  details: null,
  secretKey: null,
  offlineToken: null,
});

export const onGetApplicationDetailsSuccess = (state: IntegrationsState) => ({
  payload,
}: Object) => ({
  ...state,
  details: payload || null,
});

export const onSaveApplicationSuccess = (state: IntegrationsState) => () => ({
  ...state,
  isLoading: false,
  applicationFormModal: { ...closedModal },
});

export const onDeleteApplicationSuccess = (state: IntegrationsState) => () => ({
  ...state,
  isLoading: false,
  deleteModal: { ...closedModal },
});

export const onSecretKeySuccess = (state: IntegrationsState) => ({ payload }: Object) => ({
  ...state,
  isLoading: false,
  secretKey: (payload && payload.id) || null,
});

export const onSecretKeyError = (state: IntegrationsState) => () => ({
  ...state,
  isLoading: false,
  secretKey: null,
});

export const onOfflineTokenSuccess = (state: IntegrationsState) => ({ payload }: Object) => ({
  ...state,
  isLoading: false,
  offlineToken: (payload && payload.offlineToken) || null,
});

export const onOfflineTokenError = (state: IntegrationsState) => () => ({
  ...state,
  isLoading: false,
  offlineToken: null,
});

export const onToggleApplicationFormModal = (state: IntegrationsState) => ({
  payload,
}: Object) => ({
  ...state,
  applicationFormModal: toModalState(payload),
});

export const onToggleDeleteModal = (state: IntegrationsState) => ({ payload }: Object) => ({
  ...state,
  deleteModal: toModalState(payload),
});

export const onToggleTokenModal = (state: IntegrationsState) => ({ payload }: Object) => ({
  ...state,
  secretKey: null,
  offlineToken: null,
  tokenModal: toModalState(payload),
});
